// application level constants
import config from 'config'; // eslint-disable-line

export const META_DESCRIPTION = 'TV Testing Remote UI';

export const APPLE_COLOR = '#CC0000';
export const TANGERINE_COLOR = '#FF6600';
export const MELON_COLOR = '#FF9900';
export const BLACK_COLOR = '#000000';
export const STONE_COLOR = '#999999';
export const GRAPHITE_COLOR = '#414650';
export const PLATINUM_COLOR = '#CCCCCC';
export const ICE_COLOR = '#F5F5F5';
export const WHITE_COLOR = '#FFFFFF';
export const SOFT_GREY_COLOR = '#EDEFF3'; // used for some table headers
export const LG_COLOR = '#a50135';
export const MAIN_BLUE_COLOR = '#165177';

export const CHARTS_FILL_COLOR = '#CC0000';
export const CHARTS_GRAY_COLOR = '#4C424C';
export const CHART_FONT_FAMILY = 'Montserrat';
export const BLACKISH_FONT_COLOR = '#333';
export const LIGHT_GREY_COLOR = '#999999';

export const DEFAULT_REGION_CODE = 'DVB';
